import { actions, selectors } from '@sloyd/store-base';
import { put, select } from 'saga-ts';
import { playSfx } from 'shared-base';

export function* playKeyframeAudio(keyframe: IKeyframe) {
  const { valuesKeyframe: values } = keyframe;

  const allFrames = yield* select(selectors.base.$audioKeyframes);
  const index = allFrames.findIndex((f: IKeyframe) => f.id === keyframe.id);

  yield put(actions.animationState.patch({ storyLineIndex: index }));

  playSfx(values.src as string);
}
